import { render, staticRenderFns } from "./CommonLayout.vue?vue&type=template&id=63c094a6&scoped=true"
import script from "./CommonLayout.vue?vue&type=script&lang=js"
export * from "./CommonLayout.vue?vue&type=script&lang=js"
import style0 from "./CommonLayout.vue?vue&type=style&index=0&id=63c094a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c094a6",
  null
  
)

export default component.exports